// CW6.2.7: lightweight shimmer skeletons for reporting + list screens.
// No external deps; animations use Tailwind's built-in `animate-pulse`.
export function Skeleton({ className = "", width, height, rounded = "md" }) {
  const style = {};
  if (width) style.width = width;
  if (height) style.height = height;
  const r =
    rounded === "full" ? "rounded-full"
      : rounded === "lg" ? "rounded-lg"
      : rounded === "sm" ? "rounded-sm"
      : "rounded-md";
  return (
    <div
      className={`animate-pulse bg-black/10 ${r} ${className}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export function SkeletonTile() {
  return (
    <div className="cw-card p-4 space-y-3" data-testid="skeleton-tile">
      <Skeleton height="12px" width="40%" />
      <Skeleton height="28px" width="60%" />
      <Skeleton height="10px" width="80%" />
    </div>
  );
}

export function SkeletonLine({ widthPct = 100 }) {
  return <Skeleton height="12px" width={`${widthPct}%`} />;
}

export function SkeletonRows({ rows = 6 }) {
  return (
    <div className="space-y-2" data-testid="skeleton-rows">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} height="40px" />
      ))}
    </div>
  );
}
